export const initialState = {
  actionProcessing: false,
  currentGifts: {
    items: [],
    count: 0,
  },
  currentGiftsUpdateTrigger: {},
  giftRequests: {
    items: [],
    count: 0,
  },
  christmasTournament: {
    items: [],
    agentData: {
      position: -1,
      username: '',
      points: -1,
    },
  },
  jacktopTournament: {
    items: [],
    agentData: {
      position: -1,
      username: '',
      points: -1,
    },
  },
  rubyPlayTournament: {
    items: [],
    agentData: {
      position: -1,
      username: '',
      points: -1,
    },
  },
  netentTournament: {
    items: [],
    agentData: {
      position: -1,
      username: '',
      points: -1,
    },
  },
  promotions: {
    items: [],
    count: 0,
    promotionById: null,
  },
};
